module.exports = __webpack_public_path__ + "img/Employee directory Icon - charcoal.680808ce.svg";